"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Menu = void 0;

var _react = _interopRequireWildcard(require("react"));

var S = _interopRequireWildcard(require("./styled"));

var Menu = (0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(S.Menu, Object.assign({}, props, {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    getContentAnchorEl: null,
    classes: {
      paper: 'liva-menu-paper'
    },
    ref: ref
  }));
});
exports.Menu = Menu;
var _default = Menu;
exports["default"] = _default;